import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-5\" id=\"custom\"><a href=\"#custom\"></a> Custom Example </h1><div class=\"py-5\"> Add <code>.carousel-custom</code> to use a customized carousel as shown below: </div><div class=\"py-5\"><div class=\"rounded border p-10\"><div id=\"kt_carousel_1_carousel\" class=\"carousel carousel-custom slide\" data-bs-ride=\"carousel\" data-bs-interval=\"8000\"><div class=\"d-flex align-items-center justify-content-between flex-wrap\"><span class=\"fs-4 fw-bolder pe-2\">Projects</span><ol class=\"p-0 m-0 carousel-indicators carousel-indicators-dots\"><li data-bs-target=\"#kt_carousel_1_carousel\" data-bs-slide-to=\"0\" class=\"ms-1 active\"></li><li data-bs-target=\"#kt_carousel_1_carousel\" data-bs-slide-to=\"1\" class=\"ms-1\"></li><li data-bs-target=\"#kt_carousel_1_carousel\" data-bs-slide-to=\"2\" class=\"ms-1\"></li></ol></div><div class=\"carousel-inner pt-8\"><div class=\"carousel-item active\"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry&#39;s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. </div><div class=\"carousel-item\"> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry&#39;s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. </div><div class=\"carousel-item\"> Lorem Ipsum has been the industry&#39;s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. </div></div></div></div></div>", 3)
const _hoisted_5 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_CodeHighlighter, {
        fieldHeight: "400",
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`
        <div
          id="kt_carousel_1_carousel"
          class="carousel carousel-custom slide"
          data-bs-ride="carousel"
          data-bs-interval="8000"
        >
          <!--begin::Heading-->
          <div
            class="d-flex align-items-center justify-content-between flex-wrap"
          >
            <!--begin::Label-->
            <span class="fs-4 fw-bolder pe-2">Projects</span>
            <!--end::Label-->

            <!--begin::Carousel Indicators-->
            <ol class="p-0 m-0 carousel-indicators carousel-indicators-dots">
              <li
                data-bs-target="#kt_carousel_1_carousel"
                data-bs-slide-to="0"
                class="ms-1 active"
              ></li>
              <li
                data-bs-target="#kt_carousel_1_carousel"
                data-bs-slide-to="1"
                class="ms-1"
              ></li>
              <li
                data-bs-target="#kt_carousel_1_carousel"
                data-bs-slide-to="2"
                class="ms-1"
              ></li>
            </ol>
            <!--end::Carousel Indicators-->
          </div>
          <!--end::Heading-->

          <!--begin::Carousel-->
          <div class="carousel-inner pt-8">
            <!--begin::Item-->
            <div class="carousel-item active">
              ...
            </div>
            <!--end::Item-->

            <!--begin::Item-->
            <div class="carousel-item">
              ...
            </div>
            <!--end::Item-->

            <!--begin::Item-->
            <div class="carousel-item">
              ...
            </div>
            <!--end::Item-->
          </div>
          <!--end::Carousel-->
        </div>
        `), 1)
        ]),
        _: 1
      })
    ])
  ]))
}